<template>
  <el-drawer v-model="val" custom-class="pro-drawer" destroy-on-close>
    <template #title>
      <h4>考勤详情</h4>
    </template>
    
    <el-descriptions
          class="margin-top"
          :column="1"
          border
          width="150px"
      >
        <el-descriptions-item label="姓名：" label-class-name="wage-detail-info-item-label" >
            {{workAttendance.name}}
        </el-descriptions-item>
        <el-descriptions-item label="电话：">
            {{workAttendance.phone}}
        </el-descriptions-item>
        <el-descriptions-item label="所在项目层级：">
            {{projectLabel}}
        </el-descriptions-item>
        <el-descriptions-item label="围栏内打卡次数：">
            {{workAttendance.isRange}}
        </el-descriptions-item>
        <el-descriptions-item label="自动打卡次数：">
            {{workAttendance.noManual}}
        </el-descriptions-item>
        <el-descriptions-item label="打卡次数：">
            {{workAttendance.count}}
        </el-descriptions-item>
        
    </el-descriptions>

    <el-alert title="明细" :closable="false" style="margin-top:20px"></el-alert>

    <ul v-infinite-scroll="loadInfiniteData" class="infinite-list" style="overflow: auto">
      <li v-for="wa in infiniteData" :key="wa.id" class="infinite-item">
        <el-row class="item-top">
          <el-avatar :size="10"></el-avatar>
          <span v-text="wa.clockTimeString"></span>  
          <el-tag v-if="wa.isClockManual">手动</el-tag>
          <el-tag v-else type="warning">系统</el-tag>
          <el-tag v-if="wa.isClockRange" >围栏内</el-tag>
          <el-tag v-else type="warning">围栏外</el-tag>
        </el-row>
        <div v-text="wa.clockAddress" class="item-address"></div>
        <div class="item-map">
          <el-button type="text" @click="toShowMap(wa)">查看地图</el-button>
        </div>
      </li>
    </ul>

    <work-attendance-map v-model="mapVisible" :workAttendance="currWorkAttendance" />
  </el-drawer>
</template>
<script>

import { getProjectUserWorkAttendances } from "@/api/work";
import { getFileUrl } from "@/utils/common";
import { defineComponent } from "vue";
import WorkAttendanceMap from '../WorkAttendanceMap.vue';


export default defineComponent({
  emits: ["update:modelValue"],
  components: { WorkAttendanceMap },
  data() {
    return {
      getFileUrl,
      mapVisible: false,
      workAttendances: [],
      currWorkAttendance: {}, // 选中的
      infiniteData: [],
      offset: 0
    };
  },
  props: {
    modelValue: Boolean,
    params: Object,
    workAttendance: Object
  },
  computed: {
    val: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },
    projectLabel() {
      let workAttendance = this.workAttendance;
      if (workAttendance.groupName) return workAttendance.groupName;
      if (workAttendance.teamName) return workAttendance.teamName;
      if (workAttendance.projectName) return workAttendance.projectName;
      return '';
    }
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.workAttendances = [];
        this.infiniteData = [];
        this.offset = 0;
        this.getDetails();
      }
    }
  },
  methods: {
    getDetails() {
      let params = {
        projectId: this.workAttendance.projectId,
        userId: this.workAttendance.userId,
        startDate: this.params.startDate,
        endDate: this.params.endDate
      }
      getProjectUserWorkAttendances(params).then(({data}) => {
        this.offset = 0;
        this.workAttendances = data.data;
        this.loadInfiniteData();
      })
    },
    loadInfiniteData() {
      if (this.offset > this.workAttendances.length) {
        return;
      }
      let end = this.offset + 10;
      this.infiniteData.push(...this.workAttendances.slice(this.offset, end));
      this.offset = end;
    },
    toShowMap(currWorkAttendance) {
      this.currWorkAttendance = currWorkAttendance;
      this.mapVisible = true;
    }
  }
});
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" >
.pro-drawer {
  .el-drawer__header {
    padding: 0px 10px 0px 10px;
    background: #f7f7f7;
    margin-bottom: 0px;
  }
}
.infinite-list {
  height: calc(100% - 250px);
  min-height: 150px;
  padding: 0 5px 0 0;
  margin: 15px 0 0;
  list-style: none;
  .infinite-item {
    & + .infinite-item {
      margin-top: 15px;
    }
    border: 1px solid var(--el-card-border-color);
    border-radius: 4px;
    padding: 20px;
    .item-top {
      align-items: center;
      >span:last-child {
        margin-left: 10px;
      }
    }
    .item-bottom {
      padding-left: 21px;
      margin-top: 5px;
    }
  }
}
.work-item {
  & + .work-item {
    margin-top: 15px;
  }
  .item-top {
    align-items: center;
    >span:last-child {
      margin-left: 10px;
    }
  }
  .item-address,
  .item-map {
    padding-left: 21px;
    margin-top: 5px;
  }
}
.wage-detail-info-item-label {
  width: 140px;
}
</style>